import React from "react";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  breadcrumbText: {
    fontSize: "14px",
  },
  adjustDividerTop: {
    marginBottom: "10px",
  },
  adjustDividerBottom: {
    marginTop: "10px",
  },
  routerLinkStyle: {
    textDecoration: "none",
    color: "#656D78",
  },
}));

interface Props {
  title: string;
}

export const MaintenanceBreadcrumbs: React.FC<Props> = ({ title }) => {
  const classes = useStyles();
  return (
    <div>
      <div className={classes.root}>
        <Breadcrumbs
          separator={<NavigateNextIcon className={classes.breadcrumbText} />}
          aria-label="breadcrumb"
        >
          <Link className={classes.breadcrumbText} color="inherit">
            <RouterLink className={classes.routerLinkStyle} to="/">
              Home
            </RouterLink>
          </Link>
          <Link className={classes.breadcrumbText} color="inherit">
            <RouterLink
              className={classes.routerLinkStyle}
              to="/dashboard/admin/maintenance/"
            >
              Maintenance
            </RouterLink>
          </Link>
          <Typography color="textPrimary">{title}</Typography>
        </Breadcrumbs>
      </div>
      <div className={classes.adjustDividerTop}></div>
      <Divider />
      <div className={classes.adjustDividerBottom}></div>
    </div>
  );
};
